import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-allergies.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetAllergiesDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metAllergiesEntity = useAppSelector(state => state.metAllergies.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metAllergiesDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metAllergies.detail.title">MetAllergies</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metAllergiesEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metAllergies.code">Code</Translate>
            </span>
          </dt>
          <dd>{metAllergiesEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metAllergies.name">Name</Translate>
            </span>
          </dt>
          <dd>{metAllergiesEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metAllergies.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{metAllergiesEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metAllergies.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{metAllergiesEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metAllergies.status">Status</Translate>
            </span>
          </dt>
          <dd>{metAllergiesEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-allergies" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-allergies/${metAllergiesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetAllergiesDetail;
